import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@/core/services/auth.service';
import { Observable } from 'rxjs';

/**
 * MfaGuard - Protects MFA verification routes
 * Only allows access if MFA is pending
 */
@Injectable({
  providedIn: 'root'
})
export class MfaGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const isAuthenticated = await this.authService.isAuthenticated();
      if (!isAuthenticated) {
        this.router.navigate(['/landing/login']);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error in MfaGuard:', error);
      this.router.navigate(['/landing/login']);
      return false;
    }
  }
}
